// @ts-ignore
import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import { FieldInputProps } from 'formik';
import { DatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import isValid from 'date-fns/isValid'; // používáme isValid z date-fns

interface FieldDateInterface {
    field: FieldInputProps<any>;
    form: {
        touched: any;
        errors: any;
        setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
    };
    fullWidth?: boolean;
    label?: string;
    format?: string;
}

const FieldDate = ({
    field,
    form: { touched, errors, setFieldValue },
    fullWidth,
    label,
    format = 'dd.MM.yyyy',
    ...props
}: FieldDateInterface) => {
    const hasError = touched[field.name] && !!errors[field.name];
    const errorText = hasError ? errors[field.name] : '';

    const handleClear = (event: React.MouseEvent) => {
        event.stopPropagation();
        setFieldValue(field.name, null);
    };

    const handleChange = (date: any) => {
        if (!date || !isValid(date)) {
            setFieldValue(field.name, null);
        } else {
            setFieldValue(field.name, date);
        }
    };

    return (
        <FormControl fullWidth={fullWidth}>
            <DatePicker
                value={field.value || null}
                onChange={handleChange}
                format={format}
                label={label}
                TextFieldComponent={(textFieldProps) => (
                    <TextField
                        {...textFieldProps}
                        error={hasError}
                        helperText={errorText}
                        variant="outlined"
                        InputProps={{
                            ...textFieldProps.InputProps,
                            endAdornment: (
                                <>
                                    {field.value && (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleClear} size="small">
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )}
                                    {textFieldProps.InputProps?.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
                {...props}
            />
        </FormControl>
    );
};

export default FieldDate;
